import registerAlias from '../../../common/alias/index';
import component from './Alias';

import { TOOLS } from '../../workspace/toolbar/toolbarConstants';

export default () =>
    registerAlias({
        containerComponent: component,
        presentationalComponent: component,
        tools: [TOOLS.COLOR, TOOLS.ICON],
        showTool: false,
    });
